{
  "about.blocks": "Servidors moderats",
  "about.contact": "Contacte:",
  "about.default_locale": "Per defecte",
  "about.disclaimer": "Mastodon és programari lliure de codi obert i una marca comercial de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "No es disposa del motiu",
  "about.domain_blocks.preamble": "En general, Mastodon permet de veure el contingut i interaccionar amb els usuaris de qualsevol altre servidor del fedivers. Aquestes són les excepcions d'aquest servidor en particular.",
  "about.domain_blocks.silenced.explanation": "Generalment no veuràs perfils ni contingut d'aquest servidor, a menys que el cerquis explícitament o optis per seguir-lo.",
  "about.domain_blocks.silenced.title": "Limitat",
  "about.domain_blocks.suspended.explanation": "No es processaran, emmagatzemaran ni intercanviaran dades d'aquest servidor, fent impossible qualsevol interacció o comunicació amb els seus usuaris.",
  "about.domain_blocks.suspended.title": "Suspès",
  "about.language_label": "Idioma",
  "about.not_available": "Aquesta informació no és disponible en aquest servidor.",
  "about.powered_by": "Xarxa social descentralitzada impulsada per {mastodon}",
  "about.rules": "Normes del servidor",
  "account.account_note_header": "Nota personal",
  "account.activity": "Activitat",
  "account.add_note": "Afegeix una nota personal",
  "account.add_or_remove_from_list": "Afegeix o elimina de les llistes",
  "account.badges.admin": "Administrador",
  "account.badges.blocked": "Blocat",
  "account.badges.bot": "Automatitzat",
  "account.badges.domain_blocked": "Domini blocat",
  "account.badges.group": "Grup",
  "account.badges.muted": "Silenciat",
  "account.block": "Bloca @{name}",
  "account.block_domain": "Bloca el domini {domain}",
  "account.block_short": "Bloca",
  "account.blocked": "Blocat",
  "account.cancel_follow_request": "Cancel·la el seguiment",
  "account.copy": "Copia l'enllaç al perfil",
  "account.direct": "Menciona privadament @{name}",
  "account.disable_notifications": "Deixa de notificar-me els tuts de @{name}",
  "account.edit_note": "Edita una nota personal",
  "account.edit_profile": "Edita el perfil",
  "account.edit_profile_short": "Edita",
  "account.enable_notifications": "Notifica'm els tuts de @{name}",
  "account.endorse": "Recomana en el perfil",
  "account.familiar_followers_many": "Seguit per {name1}, {name2} i {othersCount, plural, one {# altre compte} other {# altres comptes}} que coneixeu",
  "account.familiar_followers_one": "Seguit per {name1}",
  "account.familiar_followers_two": "Seguit per {name1} i {name2}",
  "account.featured": "Destacat",
  "account.featured.accounts": "Perfils",
  "account.filters.all": "Tota l'activitat",
  "account.filters.boosts_toggle": "Mostra els impulsos",
  "account.filters.posts_boosts": "Publicacions i impulsos",
  "account.filters.posts_only": "Publicacions",
  "account.filters.posts_replies": "Publicacions i respostes",
  "account.filters.replies_toggle": "Mostra les respostes",
  "account.follow": "Segueix",
  "account.follow_back": "Segueix tu també",
  "account.follow_back_short": "Segueix tu també",
  "account.follow_request": "Sol·licita seguir",
  "account.follow_request_cancel": "Cancel·la la petició",
  "account.follow_request_cancel_short": "Cancel·la",
  "account.follow_request_short": "Petició",
  "account.followers": "Seguidors",
  "account.followers.empty": "A aquest usuari encara no el segueix ningú.",
  "account.followers_counter": "{count, plural, one {{counter} seguidor} other {{counter} seguidors}}",
  "account.followers_you_know_counter": "{counter} que coneixeu",
  "account.following": "Seguint",
  "account.following_counter": "{count, plural, other {Seguint-ne {counter}}}",
  "account.follows.empty": "Aquest usuari encara no segueix ningú.",
  "account.follows_you": "Us segueix",
  "account.go_to_profile": "Vés al perfil",
  "account.hide_reblogs": "Amaga els impulsos de @{name}",
  "account.in_memoriam": "En Memòria.",
  "account.joined_short": "S'hi va unir",
  "account.languages": "Canvia les llengües subscrites",
  "account.link_verified_on": "La propietat d'aquest enllaç es va verificar el dia {date}",
  "account.locked_info": "L'estat de privacitat del compte està definit com a blocat. El propietari revisa manualment qui pot seguir-lo.",
  "account.media": "Contingut",
  "account.mention": "Menciona @{name}",
  "account.menu.add_to_list": "Afegir a la llista…",
  "account.menu.block": "Blocar el compte",
  "account.menu.block_domain": "Blocar {domain}",
  "account.menu.copied": "Compte copiat al porta-retalls",
  "account.menu.copy": "Copiar l'enllaç",
  "account.menu.direct": "Mencionar privadament",
  "account.menu.hide_reblogs": "Amagar impulsos en les línies de temps",
  "account.menu.mention": "Mencionar",
  "account.menu.mute": "Silenciar el compte",
  "account.menu.open_original_page": "Veure a {domain}",
  "account.menu.remove_follower": "Eliminar el seguidor",
  "account.menu.report": "Denunciar el compte",
  "account.menu.share": "Compartir…",
  "account.menu.show_reblogs": "Mostrar impulsos en les línies de temps",
  "account.menu.unblock": "Desblocar el compte",
  "account.menu.unblock_domain": "Desblocar {domain}",
  "account.menu.unmute": "Deixar de silenciar el compte",
  "account.moved_to": "{name} ha indicat que el seu nou compte és:",
  "account.mute": "Silencia @{name}",
  "account.mute_notifications_short": "Silencia les notificacions",
  "account.mute_short": "Silencia",
  "account.muted": "Silenciat",
  "account.mutual": "Us seguiu l'un a l'altre",
  "account.no_bio": "No s'ha proporcionat cap descripció.",
  "account.node_modal.callout": "Ningú més pot veure les vostres notes personals.",
  "account.node_modal.edit_title": "Edita una nota personal",
  "account.node_modal.error_unknown": "No s'ha pogut desar la nota",
  "account.node_modal.field_label": "Nota Personal",
  "account.node_modal.save": "Desa",
  "account.node_modal.title": "Afegeix una nota personal",
  "account.note.edit_button": "Edita",
  "account.note.title": "Nota personal (visible només per a vós)",
  "account.open_original_page": "Obre la pàgina original",
  "account.posts": "Tuts",
  "account.remove_from_followers": "Elimina {name} dels seguidors",
  "account.report": "Informa sobre @{name}",
  "account.requested_follow": "{name} ha demanat de seguir-te",
  "account.share": "Comparteix el perfil de @{name}",
  "account.show_reblogs": "Mostra els impulsos de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publicació} other {{counter} publicacions}}",
  "account.unblock": "Desbloca @{name}",
  "account.unblock_domain": "Desbloca el domini {domain}",
  "account.unblock_domain_short": "Desbloca",
  "account.unblock_short": "Desbloca",
  "account.unendorse": "No recomanis en el perfil",
  "account.unfollow": "Deixa de seguir",
  "account.unmute": "Deixa de silenciar @{name}",
  "account.unmute_notifications_short": "Deixa de silenciar les notificacions",
  "account.unmute_short": "Deixa de silenciar",
  "account_note.placeholder": "Clica per a afegir-hi una nota",
  "admin.dashboard.daily_retention": "Ràtio de retenció d'usuaris per dia, després de registrar-se",
  "admin.dashboard.monthly_retention": "Ràtio de retenció d'usuaris per mes, després de registrar-se",
  "admin.dashboard.retention.average": "Mitjana",
  "admin.dashboard.retention.cohort": "Mes de registre",
  "admin.dashboard.retention.cohort_size": "Usuaris nous",
  "admin.impact_report.instance_accounts": "Perfils de comptes que això eliminaria",
  "admin.impact_report.instance_followers": "Seguidors que els nostres usuaris perdrien",
  "admin.impact_report.instance_follows": "Seguidors que els seus usuaris perdrien",
  "admin.impact_report.title": "Resum del impacte",
  "alert.rate_limited.message": "Proveu-ho una altra vegada al cap de {retry_time, time, medium}.",
  "alert.rate_limited.title": "Límit de freqüència",
  "alert.unexpected.message": "S'ha produït un error inesperat.",
  "alert.unexpected.title": "Vaja!",
  "alt_text_badge.title": "Text alternatiu",
  "alt_text_modal.add_alt_text": "Afegiu text alternatiu",
  "alt_text_modal.add_text_from_image": "Afegiu text d'una imatge",
  "alt_text_modal.cancel": "Cancel·la",
  "alt_text_modal.change_thumbnail": "Canvia la miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Descriviu això per a persones amb problemes d'audició…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Descriviu això per a persones amb problemes visuals…",
  "alt_text_modal.done": "Fet",
  "announcement.announcement": "Anunci",
  "annual_report.announcement.action_build": "El meu Wrapstodon s'ha fet",
  "annual_report.announcement.action_dismiss": "No, gràcies",
  "annual_report.announcement.action_view": "Vegeu el meu Wrapstodon",
  "annual_report.announcement.description": "Descobriu més sobre el vostre involucrament a Mastodon durant l'any passat.",
  "annual_report.announcement.title": "Ha arribat Wrapstodon {year}",
  "annual_report.nav_item.badge": "Nou",
  "annual_report.shared_page.donate": "Fer una donació",
  "annual_report.shared_page.footer": "Generat amb {heart} per l'equip de Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} fa servir {domain} una de les moltes comunitats basades en Mastodon.",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabem que {name} hi era, a alguna banda, gaudint de Mastodon a la seva manera discreta.",
  "annual_report.summary.copy_link": "Copia l'enllaç",
  "annual_report.summary.most_used_app.most_used_app": "l'aplicació més utilitzada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "l'etiqueta més utilitzada",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} ha inclòs aquesta etiqueta a {count, plural, one {una publicació} other {# publicacions}}.",
  "annual_report.summary.new_posts.new_posts": "publicacions noves",
  "annual_report.summary.percentile.text": "<topLabel>Que us posa al</topLabel><percentage></percentage><bottomLabel>capdamunt dels usuaris de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "No li ho direm al Bernie.",
  "annual_report.summary.share_elsewhere": "Compartir a una altra banda",
  "annual_report.summary.share_message": "Tinc l'arquetip {archetype}!",
  "annual_report.summary.share_on_mastodon": "Compartir a Mastodon",
  "attachments_list.unprocessed": "(sense processar)",
  "audio.hide": "Amaga l'àudio",
  "block_modal.remote_users_caveat": "Li demanarem al servidor {domain} que respecti la vostra decisió, tot i que no podem garantir-ho, ja que alguns servidors gestionen de forma diferent els blocatges. És possible que els usuaris no autenticats puguin veure les publicacions públiques.",
  "block_modal.show_less": "Mostra'n menys",
  "block_modal.show_more": "Mostra'n més",
  "block_modal.they_will_know": "Poden veure que els heu blocat.",
  "block_modal.title": "Bloquem l'usuari?",
  "boost_modal.combo": "Pots prémer {combo} per a evitar-ho el pròxim cop",
  "boost_modal.reblog": "Voleu impulsar la publicació?",
  "boost_modal.undo_reblog": "Voleu retirar l'impuls a la publicació?",
  "bundle_column_error.copy_stacktrace": "Copia l'informe d'error",
  "bundle_column_error.error.body": "No s'ha pogut renderitzar la pàgina sol·licitada. Podria ser per un error en el nostre codi o per un problema de compatibilitat del navegador.",
  "bundle_column_error.error.title": "Oh, no!",
  "bundle_column_error.network.body": "Hi ha hagut un error en intentar carregar aquesta pàgina. Podria ser per un problema temporal amb la teva connexió a internet o amb aquest servidor.",
  "bundle_column_error.network.title": "Error de xarxa",
  "bundle_column_error.retry": "Torna-ho a provar",
  "bundle_column_error.return": "Torna a Inici",
  "bundle_column_error.routing.body": "No es pot trobar la pàgina sol·licitada. Segur que l'enllaç que has introduït és correcte?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Tanca",
  "bundle_modal_error.message": "S'ha produït un error en carregar aquesta pantalla.",
  "bundle_modal_error.retry": "Torna-ho a provar",
  "callout.dismiss": "Omet",
  "carousel.current": "<sr>Diapositiva</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositiva {current, number} de {max, number}",
  "closed_registrations.other_server_instructions": "Com que Mastodon és descentralitzat, pots crear un compte en un altre servidor i continuar interactuant amb aquest.",
  "closed_registrations_modal.description": "No es pot crear un compte a {domain} ara mateix, però tingues en compte que no necessites específicament un compte a {domain} per a usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Troba un altre servidor",
  "closed_registrations_modal.preamble": "Mastodon és descentralitzat. Per tant, tinguis on tinguis el compte, seràs capaç de seguir i interactuar amb tothom des d'aquest servidor. Fins i tot pots tenir el compte en el teu propi servidor!",
  "closed_registrations_modal.title": "Registrant-se a Mastodon",
  "collections.account_count": "{count, plural, one {# compte} other {# comptes}}",
  "collections.collection_description": "Descripció",
  "collections.collection_name": "Nom",
  "collections.collection_topic": "Tema",
  "collections.create_collection": "Crea una coŀlecció",
  "collections.delete_collection": "Elimina la coŀlecció",
  "collections.description_length_hint": "Límit de 100 caràcters",
  "collections.last_updated_at": "Última actualització: {date}",
  "collections.mark_as_sensitive": "Marcar com a sensible",
  "collections.mark_as_sensitive_hint": "Amaga la descripció i els comptes de la coŀlecció rere un avís de contingut. El nom de la coŀlecció serà encara visible.",
  "collections.topic_hint": "Afegir una etiqueta que ajudi altres a entendre el tema principal de la coŀlecció.",
  "collections.view_collection": "Mostra la coŀlecció",
  "column.about": "Quant a",
  "column.blocks": "Usuaris blocats",
  "column.bookmarks": "Marcadors",
  "column.community": "Línia de temps local",
  "column.create_list": "Crea una llista",
  "column.direct": "Mencions privades",
  "column.directory": "Navega pels perfils",
  "column.domain_blocks": "Dominis blocats",
  "column.edit_list": "Edita la llista",
  "column.favourites": "Favorits",
  "column.firehose": "Tuts en directe",
  "column.firehose_local": "Canal en directe per a aquest servidor",
  "column.firehose_singular": "Canal en directe",
  "column.follow_requests": "Peticions de seguir-te",
  "column.home": "Inici",
  "column.list_members": "Gestiona els membres de la llista",
  "column.lists": "Llistes",
  "column.mutes": "Usuaris silenciats",
  "column.notifications": "Notificacions",
  "column.pins": "Tuts fixats",
  "column.public": "Línia de temps federada",
  "column_back_button.label": "Enrere",
  "column_header.hide_settings": "Amaga la configuració",
  "column_header.moveLeft_settings": "Mou la columna cap a l'esquerra",
  "column_header.moveRight_settings": "Mou la columna cap a la dreta",
  "column_header.pin": "Fixa",
  "column_header.show_settings": "Mostra la configuració",
  "column_header.unpin": "Desfixa",
  "column_search.cancel": "Cancel·la",
  "community.column_settings.local_only": "Només local",
  "community.column_settings.media_only": "Només contingut",
  "community.column_settings.remote_only": "Només remot",
  "compose.error.blank_post": "La publicació no pot estar en blanc.",
  "compose.language.change": "Canvia d'idioma",
  "compose.language.search": "Cerca idiomes...",
  "compose.published.body": "Tut publicat.",
  "compose.published.open": "Obre",
  "compose.saved.body": "Tut desat.",
  "compose_form.direct_message_warning_learn_more": "Més informació",
  "compose_form.encryption_warning": "Els tuts a Mastodon no estan xifrats punt a punt. No compartiu informació confidencial mitjançant Mastodon.",
  "compose_form.hashtag_warning": "Aquest tut no apareixerà a les llistes d'etiquetes perquè no és públic. Només els tuts públics apareixen a les cerques per etiqueta.",
  "compose_form.lock_disclaimer": "El teu compte no està {locked}. Tothom pot seguir-te i veure els tuts de només per a seguidors.",
  "compose_form.lock_disclaimer.lock": "blocat",
  "compose_form.placeholder": "Què tens al cap?",
  "compose_form.poll.duration": "Durada de l'enquesta",
  "compose_form.poll.multiple": "Opcions múltiples",
  "compose_form.poll.option_placeholder": "Opció {number}",
  "compose_form.poll.single": "Única opció",
  "compose_form.poll.switch_to_multiple": "Canvia l’enquesta per a permetre múltiples opcions",
  "compose_form.poll.switch_to_single": "Canvia l’enquesta per a permetre una única opció",
  "compose_form.poll.type": "Estil",
  "compose_form.publish": "Publica",
  "compose_form.reply": "Respon",
  "compose_form.save_changes": "Actualitza",
  "compose_form.spoiler.marked": "Elimina l'avís de contingut",
  "compose_form.spoiler.unmarked": "Afegeix avís de contingut",
  "compose_form.spoiler_placeholder": "Avís de contingut (opcional)",
  "confirmation_modal.cancel": "Cancel·la",
  "confirmations.block.confirm": "Bloca",
  "confirmations.delete.confirm": "Elimina",
  "confirmations.delete.message": "Segur que vols eliminar aquest tut?",
  "confirmations.delete.title": "Eliminar la publicació?",
  "confirmations.delete_collection.confirm": "Eliminar",
  "confirmations.delete_collection.message": "Aquesta acció no es pot desfer.",
  "confirmations.delete_collection.title": "Voleu eliminar «{name}»?",
  "confirmations.delete_list.confirm": "Elimina",
  "confirmations.delete_list.message": "Segur que vols suprimir permanentment aquesta llista?",
  "confirmations.delete_list.title": "Eliminar la llista?",
  "confirmations.discard_draft.confirm": "Descarta i continua",
  "confirmations.discard_draft.edit.cancel": "Continua l'edició",
  "confirmations.discard_draft.edit.message": "Continuar descartarà tots els canvis que hàgiu fet a la publicació que editeu.",
  "confirmations.discard_draft.edit.title": "Descartar els canvis a la publicació?",
  "confirmations.discard_draft.post.cancel": "Reprendre l'esborrany",
  "confirmations.discard_draft.post.message": "Continuar descartarà la publicació que escriviu.",
  "confirmations.discard_draft.post.title": "Descartar l'esborrany?",
  "confirmations.discard_edit_media.confirm": "Descarta",
  "confirmations.discard_edit_media.message": "Tens canvis no desats en la descripció del contingut o en la previsualització, els vols descartar?",
  "confirmations.follow_to_list.confirm": "Seguir i afegir a una llista",
  "confirmations.follow_to_list.message": "Cal seguir {name} per a afegir-lo a una llista.",
  "confirmations.follow_to_list.title": "Seguir l'usuari?",
  "confirmations.logout.confirm": "Tanca la sessió",
  "confirmations.logout.message": "Segur que vols tancar la sessió?",
  "confirmations.logout.title": "Tancar la sessió?",
  "confirmations.missing_alt_text.confirm": "Afegiu un text alternatiu",
  "confirmations.missing_alt_text.message": "La vostra publicació té contingut sense text alternatiu. Afegir-hi descripcions la farà accessible a més persones.",
  "confirmations.missing_alt_text.secondary": "Publica-la igualment",
  "confirmations.missing_alt_text.title": "Hi voleu afegir text alternatiu?",
  "confirmations.mute.confirm": "Silencia",
  "confirmations.private_quote_notify.cancel": "Torna a l'edició",
  "confirmations.private_quote_notify.confirm": "Publica la publicació",
  "confirmations.private_quote_notify.do_not_show_again": "No tornis a mostrar-me aquest missatge",
  "confirmations.private_quote_notify.message": "La persona que citeu i altres mencionades rebran una notificació i podran veure la vostra publicació, encara que no us segueixen.",
  "confirmations.private_quote_notify.title": "Voleu compartir amb seguidors i usuaris mencionats?",
  "confirmations.quiet_post_quote_info.dismiss": "No m'ho tornis a recordar",
  "confirmations.quiet_post_quote_info.got_it": "Entesos",
  "confirmations.quiet_post_quote_info.message": "Quan citeu una publicació pública discreta, la vostra publicació s'amagarà de les línies de temps de tendències.",
  "confirmations.quiet_post_quote_info.title": "Citació d'una publicació pública discreta",
  "confirmations.redraft.confirm": "Esborra i reescriu",
  "confirmations.redraft.message": "Segur que vols eliminar aquest tut i tornar a escriure'l? Es perdran tots els impulsos i els favorits, i les respostes al tut original quedaran aïllades.",
  "confirmations.redraft.title": "Esborrar i reescriure la publicació?",
  "confirmations.remove_from_followers.confirm": "Elimina el seguidor",
  "confirmations.remove_from_followers.message": "{name} deixarà de seguir-vos. Tirem endavant?",
  "confirmations.remove_from_followers.title": "Eliminem el seguidor?",
  "confirmations.revoke_quote.confirm": "Eliminar la publicació",
  "confirmations.revoke_quote.message": "Aquesta acció no es pot desfer.",
  "confirmations.revoke_quote.title": "Eliminar la publicació?",
  "confirmations.unblock.confirm": "Desbloca",
  "confirmations.unblock.title": "Desblocar {name}?",
  "confirmations.unfollow.confirm": "Deixa de seguir",
  "confirmations.unfollow.title": "Deixar de seguir {name}?",
  "confirmations.withdraw_request.confirm": "Retirar la sol·licitud",
  "confirmations.withdraw_request.title": "Retirar la sol·licitud de seguir {name}?",
  "content_warning.hide": "Amaga la publicació",
  "content_warning.show": "Mostra-la igualment",
  "content_warning.show_more": "Mostra'n més",
  "conversation.delete": "Elimina la conversa",
  "conversation.mark_as_read": "Marca com a llegida",
  "conversation.open": "Mostra la conversa",
  "conversation.with": "Amb {names}",
  "copy_icon_button.copied": "Copiat al porta-retalls",
  "copypaste.copied": "Copiat",
  "copypaste.copy_to_clipboard": "Copia al porta-retalls",
  "directory.federated": "Del fedivers conegut",
  "directory.local": "Només de {domain}",
  "directory.new_arrivals": "Arribades noves",
  "directory.recently_active": "Actius recentment",
  "disabled_account_banner.account_settings": "Paràmetres del compte",
  "disabled_account_banner.text": "El teu compte {disabledAccount} està desactivat.",
  "dismissable_banner.community_timeline": "Aquests són els tuts públics més recents d'usuaris amb els seus comptes a {domain}.",
  "dismissable_banner.dismiss": "Ometre",
  "dismissable_banner.public_timeline": "Aquestes són les publicacions més recents al Fedivers que segueixen gent a {domain}.",
  "domain_block_modal.block": "Bloca el servidor",
  "domain_block_modal.block_account_instead": "En lloc d'això, bloca @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Els usuaris d'aquest servidor poden interactuar amb les vostres publicacions antigues.",
  "domain_block_modal.they_cant_follow": "Ningú d'aquest servidor us pot seguir.",
  "domain_block_modal.they_wont_know": "No sabran que són blocats.",
  "domain_block_modal.title": "Bloquem el domini?",
  "domain_block_modal.you_will_lose_num_followers": "Perdreu {followersCount, plural, one {{followersCountDisplay} seguidor} other {{followersCountDisplay} seguidors}} i {followingCount, plural, one {{followingCountDisplay} persona} other {{followingCountDisplay} persones}} que seguiu.",
  "domain_block_modal.you_will_lose_relationships": "Perdreu seguidors i gent a qui seguiu d'aquest servidor.",
  "domain_block_modal.you_wont_see_posts": "No veureu ni les publicacions ni les notificacions dels usuaris d'aquest servidor.",
  "domain_pill.activitypub_lets_connect": "Us permet connectar i interactuar amb persones a Mastodon i també a d'altres apps socials.",
  "domain_pill.activitypub_like_language": "ActivityPub és el llenguatge que Mastodon parla amb altres xarxes socials.",
  "domain_pill.server": "Servidor",
  "domain_pill.their_handle": "El seu identificador:",
  "domain_pill.their_server": "La seva llar digital, on són totes les seves publicacions.",
  "domain_pill.their_username": "El seu identificador únic al servidor. És possible que hi hagi usuaris amb el mateix nom d'usuari a diferents servidors.",
  "domain_pill.username": "Nom d'usuari",
  "domain_pill.whats_in_a_handle": "Què constitueix un identificador?",
  "domain_pill.who_they_are": "Com que un identificador expressa qui i on s'és, podeu interactuar amb persones d'arreu de les <button>plataformes que funcionen amb ActivityPub</button>.",
  "domain_pill.who_you_are": "Com que un identificador expressa qui i on sou, les persones d'arreu de les <button>plataformes que funcionen amb ActivityPub</button> poden interactuar amb vosaltres.",
  "domain_pill.your_handle": "El vostre identificador:",
  "domain_pill.your_server": "La vostra llar digital, on són totes les vostres publicacions. No us agrada aquesta? Canvieu de servidor quan vulgueu i emporteu-vos els vostres seguidors.",
  "domain_pill.your_username": "El vostre identificador únic en aquest servidor. Hi pot haver usuaris amb el mateix nom a diferents servidors.",
  "dropdown.empty": "Seleccioneu una opció",
  "embed.instructions": "Incrusta aquest tut a la teva pàgina web copiant el codi següent.",
  "embed.preview": "Aquest aspecte tindrà:",
  "emoji_button.activity": "Activitat",
  "emoji_button.clear": "Neteja",
  "emoji_button.custom": "Personalitzat",
  "emoji_button.flags": "Banderes",
  "emoji_button.food": "Menjar i beure",
  "emoji_button.label": "Insereix un emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "No s'han trobat emojis coincidents",
  "emoji_button.objects": "Objectes",
  "emoji_button.people": "Gent",
  "emoji_button.recent": "Usats sovint",
  "emoji_button.search": "Cerca...",
  "emoji_button.search_results": "Resultats de la cerca",
  "emoji_button.symbols": "Símbols",
  "emoji_button.travel": "Viatges i llocs",
  "empty_column.account_hides_collections": "Aquest usuari ha decidit no mostrar aquesta informació",
  "empty_column.account_suspended": "Compte suspès",
  "empty_column.account_timeline": "No hi ha tuts aquí!",
  "empty_column.account_unavailable": "Perfil no disponible",
  "empty_column.blocks": "Encara no has blocat cap usuari.",
  "empty_column.bookmarked_statuses": "Encara no has marcat cap tut. Quan en marquis un, apareixerà aquí.",
  "empty_column.community": "La línia de temps local és buida. Escriu alguna cosa públicament per posar-ho tot en marxa!",
  "empty_column.direct": "Encara no tens mencions privades. Quan n'enviïs o en rebis una, et sortirà aquí.",
  "empty_column.disabled_feed": "L'administració del vostre servidor ha desactivat aquest canal.",
  "empty_column.domain_blocks": "Encara no hi ha dominis blocats.",
  "empty_column.explore_statuses": "No hi ha res en tendència ara mateix. Revisa-ho més tard!",
  "empty_column.favourited_statuses": "Encara no has afavorit cap tut. Quan ho facis, apareixerà aquí.",
  "empty_column.favourites": "Encara no ha marcat ningú aquest tut com a preferit. Quan ho faci algú apareixerà aquí.",
  "empty_column.follow_requests": "Encara no tens cap petició de seguiment. Quan en rebis una, apareixerà aquí.",
  "empty_column.followed_tags": "Encara no segueixes cap etiqueta. Quan ho facis, es mostraran aquí.",
  "empty_column.hashtag": "Encara no hi ha res en aquesta etiqueta.",
  "empty_column.home": "La teva línia de temps és buida! Segueix més gent per a emplenar-la. {suggestions}",
  "empty_column.list": "Encara no hi ha res en aquesta llista. Quan els membres facin nous tuts, apareixeran aquí.",
  "empty_column.mutes": "Encara no has silenciat cap usuari.",
  "empty_column.notification_requests": "Tot net, ja no hi ha res aquí! Quan rebeu notificacions noves, segons la vostra configuració, apareixeran aquí.",
  "empty_column.notifications": "Encara no tens notificacions. Quan altre gent interactuï amb tu, les veuràs aquí.",
  "empty_column.public": "Aquí no hi ha res! Escriu públicament alguna cosa o segueix manualment usuaris d'altres servidors per omplir-ho",
  "error.no_hashtag_feed_access": "Creeu un compte o accediu per a veure i seguir aquesta etiqueta.",
  "error.unexpected_crash.explanation": "A causa d'un error en el nostre codi o d'un problema de compatibilitat amb el navegador, aquesta pàgina no s'ha pogut mostrar correctament.",
  "error.unexpected_crash.explanation_addons": "Aquesta pàgina no s'ha pogut mostrar correctament. És probable que aquest error sigui causat per un complement del navegador o per eines de traducció automàtica.",
  "error.unexpected_crash.next_steps": "Prova d'actualitzar la pàgina. Si això no serveix, és possible que encara puguis fer servir Mastodon a través d'un navegador diferent o amb una aplicació nativa.",
  "error.unexpected_crash.next_steps_addons": "Prova de desactivar-los i actualitza la pàgina. Si això no serveix, és possible que encara puguis fer servir Mastodon amb un altre navegador o una aplicació nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copia stacktrace al porta-retalls",
  "errors.unexpected_crash.report_issue": "Informa d'un problema",
  "explore.suggested_follows": "Persones",
  "explore.title": "Tendència",
  "explore.trending_links": "Notícies",
  "explore.trending_statuses": "Tuts",
  "explore.trending_tags": "Etiquetes",
  "featured_carousel.current": "<sr>Publicació</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Publicació fixada} other {Publicacions fixades}}",
  "featured_carousel.slide": "Publicació {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "filter_modal.added.context_mismatch_explanation": "Aquesta categoria de filtre no s'aplica al context en què has accedit a aquest tut. Si també vols que el tut es filtri en aquest context, hauràs d'editar el filtre.",
  "filter_modal.added.context_mismatch_title": "El context no coincideix!",
  "filter_modal.added.expired_explanation": "La categoria d'aquest filtre ha caducat, necessitaràs canviar la seva data de caducitat per a aplicar-la.",
  "filter_modal.added.expired_title": "Filtre caducat!",
  "filter_modal.added.review_and_configure": "Per a revisar i configurar aquesta categoria de filtre, ves a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configuració del filtre",
  "filter_modal.added.settings_link": "pàgina de configuració",
  "filter_modal.added.short_explanation": "Aquest tut s'ha afegit a la següent categoria de filtre: {title}.",
  "filter_modal.added.title": "Filtre afegit!",
  "filter_modal.select_filter.context_mismatch": "no aplica en aquest context",
  "filter_modal.select_filter.expired": "caducat",
  "filter_modal.select_filter.prompt_new": "Nova categoria: {name}",
  "filter_modal.select_filter.search": "Cerca o crea",
  "filter_modal.select_filter.subtitle": "Usa una categoria existent o crea'n una de nova",
  "filter_modal.select_filter.title": "Filtra aquest tut",
  "filter_modal.title.status": "Filtra un tut",
  "filter_warning.matches_filter": "Coincideix amb el filtre “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "{count, plural, =0 {De ningú} one {D'una persona} other {De # persones}} que potser coneixes",
  "filtered_notifications_banner.title": "Notificacions filtrades",
  "firehose.all": "Tots",
  "firehose.local": "Aquest servidor",
  "firehose.remote": "Altres servidors",
  "follow_request.authorize": "Autoritza",
  "follow_request.reject": "Rebutja",
  "follow_requests.unlocked_explanation": "Tot i que el teu compte no està blocat, el personal de {domain} ha pensat que és possible que vulguis revisar manualment les sol·licituds de seguiment d’aquests comptes.",
  "follow_suggestions.curated_suggestion": "Tria de l'equip",
  "follow_suggestions.dismiss": "No ho tornis a mostrar",
  "follow_suggestions.featured_longer": "Triat personalment per l'equip de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popular entre la gent que segueixes",
  "follow_suggestions.hints.featured": "L'equip de {domain} ha seleccionat aquest perfil.",
  "follow_suggestions.hints.friends_of_friends": "Aquest perfil és popular entre la gent que seguiu.",
  "follow_suggestions.hints.most_followed": "Aquest perfil és un dels més seguits a {domain}.",
  "follow_suggestions.hints.most_interactions": "Aquest perfil ha estat rebent un munt d'atenció recentment a {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Aquest perfil és similar a d'altres que heu seguit recentment.",
  "follow_suggestions.personalized_suggestion": "Suggeriment personalitzat",
  "follow_suggestions.popular_suggestion": "Suggeriment popular",
  "follow_suggestions.popular_suggestion_longer": "Popular a {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Semblant a perfils que seguiu de fa poc",
  "follow_suggestions.view_all": "Mostra-ho tot",
  "follow_suggestions.who_to_follow": "A qui seguir",
  "followed_tags": "Etiquetes seguides",
  "footer.about": "Quant a",
  "footer.about_mastodon": "Quant a Mastodon",
  "footer.about_server": "Quant a {domain}",
  "footer.about_this_server": "Quant a",
  "footer.directory": "Directori de perfils",
  "footer.get_app": "Aconsegueix l'app",
  "footer.keyboard_shortcuts": "Dreceres de teclat",
  "footer.privacy_policy": "Política de privadesa",
  "footer.source_code": "Mostra el codi font",
  "footer.status": "Estat",
  "footer.terms_of_service": "Condicions de servei",
  "form_field.optional": "(opcional)",
  "generic.saved": "Desat",
  "getting_started.heading": "Primeres passes",
  "hashtag.admin_moderation": "Obre la interfície de moderació per a #{name}",
  "hashtag.browse": "Fulleja publicacions a #{hashtag}",
  "hashtag.browse_from_account": "Fulleja publicacions de {name} a #{hashtag}",
  "hashtag.column_header.tag_mode.all": "i {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sense {additional}",
  "hashtag.column_settings.select.no_options_message": "No s'ha trobat cap suggeriment",
  "hashtag.column_settings.select.placeholder": "Introdueix etiquetes…",
  "hashtag.column_settings.tag_mode.all": "Tots aquests",
  "hashtag.column_settings.tag_mode.any": "Qualsevol d’aquests",
  "hashtag.column_settings.tag_mode.none": "Cap d’aquests",
  "hashtag.column_settings.tag_toggle": "Inclou etiquetes addicionals per a aquesta columna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participant} other {{counter} participants}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} tut} other {{counter} tuts}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} tut} other {{counter} tuts}} avui",
  "hashtag.feature": "Destaca al perfil",
  "hashtag.follow": "Segueix l'etiqueta",
  "hashtag.mute": "Silencia #{hashtag}",
  "hashtag.unfeature": "No destaquis al perfil",
  "hashtag.unfollow": "Deixa de seguir l'etiqueta",
  "hashtags.and_other": "…i {count, plural, other {# més}}",
  "hints.profiles.followers_may_be_missing": "Es poden haver perdut seguidors d'aquest perfil.",
  "hints.profiles.follows_may_be_missing": "Es poden haver perdut seguiments d'aquest perfil.",
  "hints.profiles.posts_may_be_missing": "Es poden haver perdut algunes publicacions d'aquest perfil.",
  "hints.profiles.see_more_followers": "Vegeu més seguidors a {domain}",
  "hints.profiles.see_more_follows": "Vegeu més seguiments a {domain}",
  "hints.profiles.see_more_posts": "Vegeu més publicacions a {domain}",
  "home.column_settings.show_quotes": "Mostrar les cites",
  "home.column_settings.show_reblogs": "Mostra els impulsos",
  "home.column_settings.show_replies": "Mostra les respostes",
  "home.hide_announcements": "Amaga els anuncis",
  "home.pending_critical_update.body": "Si us plau actualitza el teu servidor Mastodon tant aviat com sigui possible!",
  "home.pending_critical_update.link": "Veure actualitzacions",
  "home.pending_critical_update.title": "Actualització de seguretat crítica disponible!",
  "home.show_announcements": "Mostra els anuncis",
  "ignore_notifications_modal.disclaimer": "Mastodon no pot informar els usuaris que heu ignorat notificacions seves.\nIgnorar notificacions no evitarà que se segueixin enviant els missatges.",
  "ignore_notifications_modal.filter_instead": "Altrament filtra",
  "ignore_notifications_modal.filter_to_act_users": "Encara podreu acceptar, rebutjar o reportar usuaris",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrar ajuda a evitar potencials confusions",
  "ignore_notifications_modal.filter_to_review_separately": "Podeu revisar separadament notificacions filtrades",
  "ignore_notifications_modal.ignore": "Ignora les notificacions",
  "ignore_notifications_modal.limited_accounts_title": "Voleu ignorar les notificacions dels comptes moderats?",
  "ignore_notifications_modal.new_accounts_title": "Voleu ignorar les notificacions dels comptes nous?",
  "ignore_notifications_modal.not_followers_title": "Voleu ignorar les notificacions de qui no us segueix?",
  "ignore_notifications_modal.not_following_title": "Voleu ignorar les notificacions de qui no seguiu?",
  "ignore_notifications_modal.private_mentions_title": "Voleu ignorar les notificacions de mencions privades no sol·licitades?",
  "info_button.label": "Ajuda",
  "info_button.what_is_alt_text": "<h1>Què és el text alternatiu?</h1> <p>El text alternatiu proporciona descripcions d'imatges per a persones amb discapacitat visual, connexions de poca amplada de banda o aquelles que busquen un context addicional.</p> <p>Podeu millorar l'accessibilitat i la comprensió per a tothom escrivint un text alternatiu clar, concís i objectiu.</p> <ul> <li>Descriviu els elements importants</li> <li>Utilitzeu frases senzilles</li> <li>Resumiu el text en imatges</li> <li>Eviteu la informació redundant</li> <li>Centreu-vos en les tendències i els aspectes clau dels elements visuals complexos (com ara diagrames o mapes)</li> </ul>",
  "interaction_modal.action": "Per a interactuar amb la publicació de {name} cal que inicieu la sessió en el servidor que feu servir.",
  "interaction_modal.go": "Endavant",
  "interaction_modal.no_account_yet": "Encara no teniu cap compte?",
  "interaction_modal.on_another_server": "A un altre servidor",
  "interaction_modal.on_this_server": "En aquest servidor",
  "interaction_modal.title": "Inicieu la sessió per a continuar",
  "interaction_modal.username_prompt": "P. ex. {example}",
  "intervals.full.days": "{number, plural, one {# dia} other {# dies}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# hores}}",
  "intervals.full.minutes": "{number, plural, one {# minut} other {# minuts}}",
  "keyboard_shortcuts.back": "Vés enrere",
  "keyboard_shortcuts.blocked": "Obre la llista d'usuaris blocats",
  "keyboard_shortcuts.boost": "Impulsa el tut",
  "keyboard_shortcuts.column": "Centra la columna",
  "keyboard_shortcuts.compose": "Centra l'àrea de composició de text",
  "keyboard_shortcuts.description": "Descripció",
  "keyboard_shortcuts.direct": "Obre la columna de mencions privades",
  "keyboard_shortcuts.down": "Abaixa a la llista",
  "keyboard_shortcuts.enter": "Obre el tut",
  "keyboard_shortcuts.favourite": "Tut afavorit",
  "keyboard_shortcuts.favourites": "Obre la llista de preferits",
  "keyboard_shortcuts.federated": "Obre la línia de temps federada",
  "keyboard_shortcuts.heading": "Dreceres de teclat",
  "keyboard_shortcuts.home": "Obre la línia de temps de l'Inici",
  "keyboard_shortcuts.hotkey": "Tecla d'accés directe",
  "keyboard_shortcuts.legend": "Mostra aquesta llegenda",
  "keyboard_shortcuts.load_more": "Centra el botó \"Carrega'n més\"",
  "keyboard_shortcuts.local": "Obre la línia de temps local",
  "keyboard_shortcuts.mention": "Esmenta l'autor",
  "keyboard_shortcuts.muted": "Obre la llista d'usuaris silenciats",
  "keyboard_shortcuts.my_profile": "Obre el teu perfil",
  "keyboard_shortcuts.notifications": "Obre la columna de notificacions",
  "keyboard_shortcuts.open_media": "Obre mèdia",
  "keyboard_shortcuts.pinned": "Obre la llista de tuts fixats",
  "keyboard_shortcuts.profile": "Obre el perfil de l'autor",
  "keyboard_shortcuts.quote": "Citar la publicació",
  "keyboard_shortcuts.reply": "Respon al tut",
  "keyboard_shortcuts.requests": "Obre la llista de sol·licituds de seguiment",
  "keyboard_shortcuts.search": "Centra la barra de cerca",
  "keyboard_shortcuts.spoilers": "Mostra/amaga el camp CW",
  "keyboard_shortcuts.start": "Obre la columna \"Primeres passes\"",
  "keyboard_shortcuts.toggle_hidden": "Mostra/amaga el text marcat com a sensible",
  "keyboard_shortcuts.toggle_sensitivity": "Mostra/amaga contingut",
  "keyboard_shortcuts.toot": "Escriu un nou tut",
  "keyboard_shortcuts.top": "Mou al capdamunt de la llista",
  "keyboard_shortcuts.translate": "per a traduir una publicació",
  "keyboard_shortcuts.unfocus": "Descentra l'àrea de composició de text/cerca",
  "keyboard_shortcuts.up": "Apuja a la llista",
  "learn_more_link.got_it": "Entesos",
  "learn_more_link.learn_more": "Per a saber-ne més",
  "lightbox.close": "Tanca",
  "lightbox.next": "Següent",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Amplia fins a la mida real",
  "lightbox.zoom_out": "Amplia fins a encabir",
  "limited_account_hint.action": "Mostra el perfil de totes maneres",
  "limited_account_hint.title": "Aquest perfil l'han amagat els moderadors de {domain}.",
  "link_preview.author": "Per {name}",
  "link_preview.more_from_author": "Més de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicació} other {{counter} publicacions}}",
  "lists.add_member": "Afegeix",
  "lists.add_to_list": "Afegeix a la llista",
  "lists.add_to_lists": "Afegeix {name} a les llistes",
  "lists.create": "Crea",
  "lists.create_a_list_to_organize": "Creeu una nova llista per a organitzar la pantalla d'inici",
  "lists.create_list": "Crea una llista",
  "lists.delete": "Elimina la llista",
  "lists.done": "Fet",
  "lists.edit": "Edita la llista",
  "lists.exclusive": "Amaga membres a Inici",
  "lists.exclusive_hint": "Si algú és a la llista, amagueu-los de la pantalla d'inici, per a no veure'n les publicacions duplicades.",
  "lists.find_users_to_add": "Troba usuaris per a afegir",
  "lists.list_members_count": "{count, plural, one {# membre} other {# membres}}",
  "lists.list_name": "Nom de la llista",
  "lists.new_list_name": "Nom de la nova llista",
  "lists.no_lists_yet": "Encara no hi ha cap llista.",
  "lists.no_members_yet": "Encara no hi ha membres.",
  "lists.no_results_found": "No s'han trobat resultats.",
  "lists.remove_member": "Elimina",
  "lists.replies_policy.followed": "Qualsevol usuari que segueixis",
  "lists.replies_policy.list": "Membres de la llista",
  "lists.replies_policy.none": "Ningú",
  "lists.save": "Desa",
  "lists.search": "Cerca",
  "lists.show_replies_to": "Inclou respostes de membres de la llista a",
  "load_pending": "{count, plural, one {# element nou} other {# elements nous}}",
  "loading_indicator.label": "Es carrega…",
  "media_gallery.hide": "Amaga",
  "moved_to_account_banner.text": "El teu compte {disabledAccount} està desactivat perquè l'has mogut a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Amaga de les notificacions",
  "mute_modal.hide_options": "Amaga les opcions",
  "mute_modal.indefinite": "Fins que els deixi de silenciar",
  "mute_modal.show_options": "Mostra les opcions",
  "mute_modal.they_can_mention_and_follow": "Us poden esmentar i seguir, però no els veureu.",
  "mute_modal.they_wont_know": "No sabran que són silenciats.",
  "mute_modal.title": "Silenciem l'usuari?",
  "mute_modal.you_wont_see_mentions": "No veureu publicacions que els esmentin.",
  "mute_modal.you_wont_see_posts": "Encara poden veure les vostres publicacions, però no veureu les seves.",
  "navigation_bar.about": "Quant a",
  "navigation_bar.account_settings": "Contrasenya i seguretat",
  "navigation_bar.administration": "Administració",
  "navigation_bar.advanced_interface": "Obre en la interfície web avançada",
  "navigation_bar.automated_deletion": "Esborrat automàtic de publicacions",
  "navigation_bar.blocks": "Usuaris blocats",
  "navigation_bar.bookmarks": "Marcadors",
  "navigation_bar.direct": "Mencions privades",
  "navigation_bar.domain_blocks": "Dominis blocats",
  "navigation_bar.favourites": "Favorits",
  "navigation_bar.filters": "Paraules silenciades",
  "navigation_bar.follow_requests": "Sol·licituds de seguiment",
  "navigation_bar.followed_tags": "Etiquetes seguides",
  "navigation_bar.follows_and_followers": "Seguint i seguidors",
  "navigation_bar.import_export": "Importació i exportació",
  "navigation_bar.lists": "Llistes",
  "navigation_bar.live_feed_local": "Canal en directe (local)",
  "navigation_bar.live_feed_public": "Canal en directe (públic)",
  "navigation_bar.logout": "Tanca la sessió",
  "navigation_bar.moderation": "Moderació",
  "navigation_bar.more": "Més",
  "navigation_bar.mutes": "Usuaris silenciats",
  "navigation_bar.opened_in_classic_interface": "Els tuts, comptes i altres pàgines especifiques s'obren per defecte en la interfície web clàssica.",
  "navigation_bar.preferences": "Preferències",
  "navigation_bar.privacy_and_reach": "Privacitat i abast",
  "navigation_bar.search": "Cerca",
  "navigation_bar.search_trends": "Cerca / En tendència",
  "navigation_panel.collapse_followed_tags": "Comprimeix el menú d'etiquetes seguides",
  "navigation_panel.collapse_lists": "Tanca el menú",
  "navigation_panel.expand_followed_tags": "Expandeix el menú d'etiquetes seguides",
  "navigation_panel.expand_lists": "Expandeix el menú",
  "not_signed_in_indicator.not_signed_in": "Cal que iniciïs la sessió per a accedir a aquest recurs.",
  "notification.admin.report": "{name} ha reportat {target}",
  "notification.admin.report_account": "{name} ha reportat {count, plural, one {una publicació} other {# publicacions}} de {target} per {category}",
  "notification.admin.report_account_other": "{name} ha reportat {count, plural, one {una publicació} other {# publicacions}} de {target}",
  "notification.admin.report_statuses": "{name} ha reportat {target} per {category}",
  "notification.admin.report_statuses_other": "{name} ha reportat {target}",
  "notification.admin.sign_up": "{name} s'ha registrat",
  "notification.admin.sign_up.name_and_others": "{name} i {count, plural, one {# altre} other {# altres}} s'han registrat",
  "notification.annual_report.message": "El vostre {year} #Wrapstodon t'espera. Desveleu els vostres moments més memorables a Mastodon!",
  "notification.annual_report.view": "Visualitzeu #Wrapstodon",
  "notification.favourite": "{name} ha afavorit el teu tut",
  "notification.favourite.name_and_others_with_link": "{name} i <a>{count, plural, one {# altre} other {# altres}}</a> han afavorit la vostra publicació",
  "notification.favourite_pm": "{name} ha afavorit la vostra menció privada",
  "notification.favourite_pm.name_and_others_with_link": "{name} i <a>{count, plural, one {un altre} other {# altres}}</a> han afavorit la vostra menció",
  "notification.follow": "{name} et segueix",
  "notification.follow.name_and_others": "{name} i <a>{count, plural, one {# altre} other {# altres}}</a> us han seguit",
  "notification.follow_request": "{name} ha sol·licitat de seguir-te",
  "notification.follow_request.name_and_others": "{name} i {count, plural, one {# altre} other {# altres}} han demanat de seguir-vos",
  "notification.label.mention": "Menció",
  "notification.label.private_mention": "Menció privada",
  "notification.label.private_reply": "Resposta en privat",
  "notification.label.quote": "{name} ha citat la vostra publicació",
  "notification.label.reply": "Resposta",
  "notification.mention": "Menció",
  "notification.mentioned_you": "{name} us ha mencionat",
  "notification.moderation-warning.learn_more": "Per a saber-ne més",
  "notification.moderation_warning": "Heu rebut un avís de moderació",
  "notification.moderation_warning.action_delete_statuses": "S'han eliminat algunes de les vostres publicacions.",
  "notification.moderation_warning.action_disable": "S'ha desactivat el vostre compte.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "S'ha marcat com a sensibles algunes de les vostres publicacions.",
  "notification.moderation_warning.action_none": "El vostre compte ha rebut un avís de moderació.",
  "notification.moderation_warning.action_sensitive": "A partir d'ara les vostres publicacions es marcaran com sensibles.",
  "notification.moderation_warning.action_silence": "S'ha limitat el vostre compte.",
  "notification.moderation_warning.action_suspend": "S'ha suspès el vostre compte.",
  "notification.own_poll": "La teva enquesta ha finalitzat",
  "notification.poll": "Ha finalitzat una enquesta que heu respost",
  "notification.quoted_update": "{name} ha editat una publicació que has citat",
  "notification.reblog": "{name} t'ha impulsat",
  "notification.reblog.name_and_others_with_link": "{name} i <a>{count, plural, one {# altre} other {# altres}}</a> han impulsat la vostra publicació",
  "notification.relationships_severance_event": "S'han perdut les connexions amb {name}",
  "notification.relationships_severance_event.account_suspension": "Un administrador de {from} ha suspès {target}; això vol dir que ja no en podreu rebre actualitzacions o interactuar-hi.",
  "notification.relationships_severance_event.domain_block": "Un administrador de {from} ha blocat {target}, incloent-hi {followersCount} dels vostres seguidors i {followingCount, plural, one {# compte} other {# comptes}} que seguiu.",
  "notification.relationships_severance_event.learn_more": "Per a saber-ne més",
  "notification.relationships_severance_event.user_domain_block": "Heu blocat {target}, eliminant {followersCount} dels vostres seguidors i {followingCount, plural, one {# compte} other {# comptes}} que seguiu.",
  "notification.status": "{name} acaba de publicar",
  "notification.update": "{name} ha editat un tut",
  "notification_requests.accept": "Accepta",
  "notification_requests.accept_multiple": "{count, plural, one {Accepta # petició…} other {Accepta # peticions…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Accepta petició} other {Accepta peticions}}",
  "notification_requests.confirm_accept_multiple.message": "Esteu a punt d'acceptar {count, plural, one {una petició de notificació} other {# peticions de notificació}}. N'esteu segurs de continuar?",
  "notification_requests.confirm_accept_multiple.title": "Acceptar peticions de notificació?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Descarta petició} other {Descarta peticions}}",
  "notification_requests.confirm_dismiss_multiple.message": "Esteu a punt de descartar {count, plural, one {una petició de notificació} other {# peticions de notificació}}. No hi {count, plural, one {} other {}} podreu tornar a accedir fàcilment. N'esteu segurs de continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "Descartar les peticions de notificació?",
  "notification_requests.dismiss": "Ignora",
  "notification_requests.dismiss_multiple": "{count, plural, one {Descarta # petició…} other {Descarta # peticions…}}",
  "notification_requests.edit_selection": "Edita",
  "notification_requests.exit_selection": "Fet",
  "notification_requests.explainer_for_limited_account": "S'han filtrat les notificacions d'aquest compte perquè un moderador l'ha limitat.",
  "notification_requests.explainer_for_limited_remote_account": "S'han filtrat les notificacions d'aquest compte perquè un moderador ha limitat el compte o el seu servidor.",
  "notification_requests.maximize": "Maximitza",
  "notification_requests.minimize_banner": "Minimitza el bàner de notificacions filtrades",
  "notification_requests.notifications_from": "Notificacions de {name}",
  "notification_requests.title": "Notificacions filtrades",
  "notification_requests.view": "Mostra les notificacions",
  "notifications.clear": "Esborra les notificacions",
  "notifications.clear_confirmation": "Segur que vols esborrar permanentment totes les teves notificacions?",
  "notifications.clear_title": "Esborrar les notificacions?",
  "notifications.column_settings.admin.report": "Nous informes:",
  "notifications.column_settings.admin.sign_up": "Registres nous:",
  "notifications.column_settings.alert": "Notificacions d'escriptori",
  "notifications.column_settings.favourite": "Favorits:",
  "notifications.column_settings.filter_bar.advanced": "Mostra totes les categories",
  "notifications.column_settings.filter_bar.category": "Barra ràpida de filtres",
  "notifications.column_settings.follow": "Nous seguidors:",
  "notifications.column_settings.follow_request": "Noves sol·licituds de seguiment:",
  "notifications.column_settings.group": "Agrupa",
  "notifications.column_settings.mention": "Mencions:",
  "notifications.column_settings.poll": "Resultats de l’enquesta:",
  "notifications.column_settings.push": "Notificacions push",
  "notifications.column_settings.quote": "Cites:",
  "notifications.column_settings.reblog": "Impulsos:",
  "notifications.column_settings.show": "Mostra a la columna",
  "notifications.column_settings.sound": "Reprodueix so",
  "notifications.column_settings.status": "Nous tuts:",
  "notifications.column_settings.unread_notifications.category": "Notificacions pendents de llegir",
  "notifications.column_settings.unread_notifications.highlight": "Destaca les notificacions no llegides",
  "notifications.column_settings.update": "Edicions:",
  "notifications.filter.all": "Totes",
  "notifications.filter.boosts": "Impulsos",
  "notifications.filter.favourites": "Favorits",
  "notifications.filter.follows": "Seguiments",
  "notifications.filter.mentions": "Mencions",
  "notifications.filter.polls": "Resultats de l'enquesta",
  "notifications.filter.statuses": "Actualitzacions de gent que segueixes",
  "notifications.grant_permission": "Concedir permís.",
  "notifications.group": "{count} notificacions",
  "notifications.mark_as_read": "Marca cada notificació com a llegida",
  "notifications.permission_denied": "Les notificacions d’escriptori no estan disponibles perquè prèviament s’ha denegat el permís al navegador",
  "notifications.permission_denied_alert": "No es poden activar les notificacions de l'escriptori perquè abans s'ha denegat el permís del navegador",
  "notifications.permission_required": "Les notificacions d'escriptori no estan disponibles perquè el permís requerit no ha estat concedit.",
  "notifications.policy.accept": "Accepta",
  "notifications.policy.accept_hint": "Mostra a notificacions",
  "notifications.policy.drop": "Ignora",
  "notifications.policy.drop_hint": "Envia al buit, no es tornarà a veure mai més",
  "notifications.policy.filter": "Filtra",
  "notifications.policy.filter_hint": "Envia a la bústia de notificacions filtrades",
  "notifications.policy.filter_limited_accounts_hint": "Limitat pels moderadors del servidor",
  "notifications.policy.filter_limited_accounts_title": "Comptes moderats",
  "notifications.policy.filter_new_accounts.hint": "Creat {days, plural, one {ahir} other {durant els # dies passats}}",
  "notifications.policy.filter_new_accounts_title": "Comptes nous",
  "notifications.policy.filter_not_followers_hint": "Incloent les persones que us segueixen fa menys {days, plural, one {d'un dia} other {de # dies}}",
  "notifications.policy.filter_not_followers_title": "Persones que no us segueixen",
  "notifications.policy.filter_not_following_hint": "Fins que no ho aproveu de forma manual",
  "notifications.policy.filter_not_following_title": "Persones que no seguiu",
  "notifications.policy.filter_private_mentions_hint": "Filtrat si no és que és en resposta a una menció vostra o si seguiu el remitent",
  "notifications.policy.filter_private_mentions_title": "Mencions privades no sol·licitades",
  "notifications.policy.title": "Gestiona les notificacions des de…",
  "notifications_permission_banner.enable": "Activa les notificacions d’escriptori",
  "notifications_permission_banner.how_to_control": "Per a rebre notificacions quan Mastodon no és obert cal activar les notificacions d’escriptori. Pots controlar amb precisió quins tipus d’interaccions generen notificacions d’escriptori després d’activar el botó {icon} de dalt.",
  "notifications_permission_banner.title": "No et perdis mai res",
  "onboarding.follows.back": "Enrere",
  "onboarding.follows.empty": "Malauradament, cap resultat pot ser mostrat ara mateix. Pots provar de fer servir la cerca o visitar la pàgina Explora per a trobar gent a qui seguir o provar-ho de nou més tard.",
  "onboarding.follows.search": "Cerca",
  "onboarding.follows.title": "Seguiu gent per a començar",
  "onboarding.profile.discoverable": "Fes el meu perfil descobrible",
  "onboarding.profile.discoverable_hint": "En acceptar d'ésser descobert a Mastodon els teus missatges poden aparèixer dins les tendències i els resultats de cerques, i el teu perfil es pot suggerir a qui tingui interessos semblants als teus.",
  "onboarding.profile.display_name": "Nom que es mostrarà",
  "onboarding.profile.display_name_hint": "El teu nom complet o el teu malnom…",
  "onboarding.profile.note": "Biografia",
  "onboarding.profile.note_hint": "Pots @mencionar altra gent o #etiquetes…",
  "onboarding.profile.title": "Configuració del perfil",
  "onboarding.profile.upload_avatar": "Importa una foto de perfil",
  "onboarding.profile.upload_header": "Importa una capçalera de perfil",
  "password_confirmation.exceeds_maxlength": "La confirmació de la contrasenya excedeix la longitud màxima",
  "password_confirmation.mismatching": "La confirmació de contrasenya no és coincident",
  "picture_in_picture.restore": "Retorna’l",
  "poll.closed": "Finalitzada",
  "poll.refresh": "Actualitza",
  "poll.reveal": "Veure els resultats",
  "poll.total_people": "{count, plural, one {# persona} other {# persones}}",
  "poll.total_votes": "{count, plural, one {# vot} other {# vots}}",
  "poll.vote": "Vota",
  "poll.voted": "Vau votar aquesta resposta",
  "poll.votes": "{votes, plural, one {# vot} other {# vots}}",
  "poll_button.add_poll": "Afegeix una enquesta",
  "poll_button.remove_poll": "Elimina l'enquesta",
  "privacy.change": "Canvia la privacitat del tut",
  "privacy.direct.long": "Tothom mencionat a la publicació",
  "privacy.direct.short": "Menció privada",
  "privacy.private.long": "Només els vostres seguidors",
  "privacy.private.short": "Seguidors",
  "privacy.public.long": "Tothom dins o fora Mastodon",
  "privacy.public.short": "Públic",
  "privacy.quote.anyone": "{visibility}, cites permeses",
  "privacy.quote.disabled": "{visibility}, cites desactivades",
  "privacy.quote.limited": "{visibility}, cites limitades",
  "privacy.unlisted.additional": "Es comporta igual que públic, excepte que la publicació no apareixerà als canals en directe o etiquetes, l'explora o a la cerca de Mastodon, fins i tot si ho heu activat a nivell de compte.",
  "privacy.unlisted.long": "Amagat dels resultats de cerca de Mastodon, de les tendències i de les línies temporals",
  "privacy.unlisted.short": "Pública però discreta",
  "privacy_policy.last_updated": "Darrera actualització {date}",
  "privacy_policy.title": "Política de Privacitat",
  "quote_error.edit": "No es poden afegir cites en editar una publicació.",
  "quote_error.poll": "Amb les enquestes no es permeten cites.",
  "quote_error.private_mentions": "Amb mencions directes no es permeten cites.",
  "quote_error.quote": "Només es permet una cita alhora.",
  "quote_error.unauthorized": "No se us permet de citar aquesta publicació.",
  "quote_error.upload": "Amb media adjunts no es permeten cites.",
  "recommended": "Recomanat",
  "refresh": "Actualitza",
  "regeneration_indicator.please_stand_by": "Espereu.",
  "regeneration_indicator.preparing_your_home_feed": "Pantalla d'inici en preparació…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "fa {number, plural, one {# dia} other {# dies}}",
  "relative_time.full.hours": "fa {number, plural, one {# hora} other {# hores}}",
  "relative_time.full.just_now": "ara mateix",
  "relative_time.full.minutes": "fa {number, plural, one {# minut} other {# minuts}}",
  "relative_time.full.seconds": "fa {number, plural, one {# segon} other {# segons}}",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "ara",
  "relative_time.minutes": "{number}min",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "avui",
  "remove_quote_hint.button_label": "Entesos",
  "remove_quote_hint.message": "Ho podeu fer des de {icon} al menú d'opcions.",
  "remove_quote_hint.title": "Voleu eliminar la vostra publicació citada?",
  "reply_indicator.attachments": "{count, plural, one {# adjunt} other {# adjunts}}",
  "reply_indicator.cancel": "Cancel·la",
  "reply_indicator.poll": "Enquesta",
  "report.block": "Bloca",
  "report.block_explanation": "No veuràs els seus tuts. Ells no podran veure els teus tuts ni et podran seguir. Podran saber que estan blocats.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Altres",
  "report.categories.spam": "Brossa",
  "report.categories.violation": "El contingut viola una o més regles del servidor",
  "report.category.subtitle": "Tria la millor coincidència",
  "report.category.title": "Explica'ns què passa amb això ({type})",
  "report.category.title_account": "perfil",
  "report.category.title_status": "tut",
  "report.close": "Fet",
  "report.comment.title": "Hi ha res més que creguis que hauríem de saber?",
  "report.forward": "Reenvia a {target}",
  "report.forward_hint": "El compte és d'un altre servidor. Vols enviar-hi també una còpia anònima de l'informe?",
  "report.mute": "Silencia",
  "report.mute_explanation": "No veuràs els seus tuts. Encara poden seguir-te i veure els teus tuts, però no sabran que han estat silenciats.",
  "report.next": "Següent",
  "report.placeholder": "Comentaris addicionals",
  "report.reasons.dislike": "No m'agrada",
  "report.reasons.dislike_description": "No és res que vulguis veure",
  "report.reasons.legal": "És il·legal",
  "report.reasons.legal_description": "Creus que viola les lleis del teu país o les del teu servidor",
  "report.reasons.other": "És una altra cosa",
  "report.reasons.other_description": "El problema no encaixa a les altres categories",
  "report.reasons.spam": "És contingut brossa",
  "report.reasons.spam_description": "Enllaços maliciosos, implicació falsa o respostes repetitives",
  "report.reasons.violation": "Viola les regles del servidor",
  "report.reasons.violation_description": "Ets conscient que trenca regles especifiques",
  "report.rules.subtitle": "Selecciona totes les aplicables",
  "report.rules.title": "Quines regles s'han violat?",
  "report.statuses.subtitle": "Selecciona totes les aplicables",
  "report.statuses.title": "Hi ha cap tut que doni suport a aquest informe?",
  "report.submit": "Envia",
  "report.target": "Es denuncia {target}",
  "report.thanks.take_action": "Aquestes són les teves opcions per a controlar el que veus a Mastodon:",
  "report.thanks.take_action_actionable": "Mentre ho revisem, pots prendre mesures contra @{name}:",
  "report.thanks.title": "No ho vols veure?",
  "report.thanks.title_actionable": "Gràcies per informar, ho investigarem.",
  "report.unfollow": "Deixa de seguir @{name}",
  "report.unfollow_explanation": "Estàs seguint aquest compte. Per no veure els seus tuts a la teva línia de temps d'Inici, deixa de seguir-lo.",
  "report_notification.attached_statuses": "{count, plural, one {{count} tut} other {{count} tuts}} adjunts",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "contingut no permès",
  "report_notification.categories.other": "Altres",
  "report_notification.categories.other_sentence": "altres",
  "report_notification.categories.spam": "Brossa",
  "report_notification.categories.spam_sentence": "brossa",
  "report_notification.categories.violation": "Violació de norma",
  "report_notification.categories.violation_sentence": "violació de normes",
  "report_notification.open": "Obre l'informe",
  "search.clear": "Esborra la cerca",
  "search.no_recent_searches": "No hi ha cerques recents",
  "search.placeholder": "Cerca",
  "search.quick_action.account_search": "Perfils coincidint amb {x}",
  "search.quick_action.go_to_account": "Anar al perfil {x}",
  "search.quick_action.go_to_hashtag": "Ves a la etiqueta {x}",
  "search.quick_action.open_url": "Obrir enllaç a Mastodon",
  "search.quick_action.status_search": "Tuts coincidint amb {x}",
  "search.search_or_paste": "Cerca o escriu l'URL",
  "search_popout.full_text_search_disabled_message": "No disponible a {domain}.",
  "search_popout.full_text_search_logged_out_message": "Només disponible amb la sessió iniciada.",
  "search_popout.language_code": "Codi de llengua ISO",
  "search_popout.options": "Opcions de cerca",
  "search_popout.quick_actions": "Accions ràpides",
  "search_popout.recent": "Cerques recents",
  "search_popout.specific_date": "data específica",
  "search_popout.user": "usuari",
  "search_results.accounts": "Perfils",
  "search_results.all": "Tots",
  "search_results.hashtags": "Etiquetes",
  "search_results.no_results": "Cap resultat.",
  "search_results.no_search_yet": "Proveu de cercar publicacions, perfils o etiquetes.",
  "search_results.see_all": "Veure'ls tots",
  "search_results.statuses": "Tuts",
  "search_results.title": "Cerca de “{q}”",
  "server_banner.about_active_users": "Gent que ha fet servir aquest servidor en els darrers 30 dies (Usuaris Actius Mensuals)",
  "server_banner.active_users": "usuaris actius",
  "server_banner.administered_by": "Administrat per:",
  "server_banner.is_one_of_many": "{domain} és un dels molts servidors de Mastodon que pots fer servir per a participar en el fedivers.",
  "server_banner.server_stats": "Estadístiques del servidor:",
  "sign_in_banner.create_account": "Crea un compte",
  "sign_in_banner.follow_anyone": "Segueix qui sigui al fedivers i ho veuràs tot en ordre cronològic. Sense algorismes, anuncis o pescaclics.",
  "sign_in_banner.mastodon_is": "Mastodon és la millor manera de seguir al moment què passa.",
  "sign_in_banner.sign_in": "Inici de sessió",
  "sign_in_banner.sso_redirect": "Inici de sessió o Registre",
  "status.admin_account": "Obre la interfície de moderació per a @{name}",
  "status.admin_domain": "Obre la interfície de moderació per a @{domain}",
  "status.admin_status": "Obre aquest tut a la interfície de moderació",
  "status.all_disabled": "S'han deshabilitat impulsos i cites",
  "status.block": "Bloca @{name}",
  "status.bookmark": "Marca",
  "status.cancel_reblog_private": "Desfés l'impuls",
  "status.cannot_quote": "No se't permet de citar aquesta publicació",
  "status.cannot_reblog": "No es pot impulsar aquest tut",
  "status.contains_quote": "Conté una cita",
  "status.context.loading": "Es carreguen més respostes",
  "status.context.loading_error": "No s'han pogut carregar respostes noves",
  "status.context.loading_success": "S'han carregat les noves respostes",
  "status.context.more_replies_found": "S'han trobat més respostes",
  "status.context.retry": "Torna-ho a provar",
  "status.context.show": "Mostra",
  "status.continued_thread": "Continuació del fil",
  "status.copy": "Copia l'enllaç al tut",
  "status.delete": "Elimina",
  "status.delete.success": "Publicació esborrada",
  "status.detailed_status": "Vista detallada de la conversa",
  "status.direct": "Menciona privadament @{name}",
  "status.direct_indicator": "Menció privada",
  "status.edit": "Edita",
  "status.edited": "Darrera edició {date}",
  "status.edited_x_times": "Editat {count, plural, one {{count} vegada} other {{count} vegades}}",
  "status.embed": "Obté el codi encastat",
  "status.favourite": "Favorit",
  "status.favourites_count": "{count, plural, one {{counter} favorit} other {{counter} favorits}}",
  "status.filter": "Filtra aquest tut",
  "status.history.created": "creat per {name} {date}",
  "status.history.edited": "editat per {name} {date}",
  "status.load_more": "Carrega'n més",
  "status.media.open": "Clica per obrir",
  "status.media.show": "Clica per a mostrar",
  "status.media_hidden": "Contingut amagat",
  "status.mention": "Esmenta @{name}",
  "status.more": "Més",
  "status.mute": "Silencia @{name}",
  "status.mute_conversation": "Silencia la conversa",
  "status.open": "Amplia el tut",
  "status.pin": "Fixa en el perfil",
  "status.quote": "Cita",
  "status.quote.cancel": "Canceŀlar la citació",
  "status.quote_error.blocked_account_hint.title": "Aquesta publicació està amagada perquè heu blocat a @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Aquesta publicació està amagada perquè heu blocat a {domain}.",
  "status.quote_error.filtered": "No es mostra a causa d'un dels vostres filtres",
  "status.quote_error.limited_account_hint.action": "Mostra-la igualment",
  "status.quote_error.limited_account_hint.title": "Aquest perfil l'han amagat els moderadors de {domain}.",
  "status.quote_error.muted_account_hint.title": "Aquesta publicació està amagada perquè heu silenciat a @{name}.",
  "status.quote_error.not_available": "Publicació no disponible",
  "status.quote_error.pending_approval": "Publicació pendent",
  "status.quote_error.pending_approval_popout.body": "A Mastodon pots controlar si algú et pot citar. Aquesta publicació està pendent mentre esperem l'aprovació de l'autor original.",
  "status.quote_error.revoked": "Publicació eliminada per l'autor",
  "status.quote_followers_only": "Només els seguidors poden citar aquesta publicació",
  "status.quote_manual_review": "L'autor ho revisarà manualment",
  "status.quote_noun": "Cita",
  "status.quote_policy_change": "Canvieu qui us pot citar",
  "status.quote_post_author": "S'ha citat una publicació de @{name}",
  "status.quote_private": "No es poden citar les publicacions privades",
  "status.quotes.empty": "Encara no ha citat aquesta publicació ningú. Quan ho faci algú apareixerà aquí.",
  "status.quotes.local_other_disclaimer": "No es mostraran les cites rebutjades per l'autor.",
  "status.quotes.remote_other_disclaimer": "Només es garanteix que es mostraran aquí les cites de {domain}. No es mostraran les rebutjades per l'autor.",
  "status.quotes_count": "{count, plural, one {{counter} citació} other {{counter} citacions}}",
  "status.read_more": "Més informació",
  "status.reblog": "Impulsa",
  "status.reblog_or_quote": "Impuls or cita",
  "status.reblog_private": "Compartiu de nou amb els vostres seguidors",
  "status.reblogged_by": "impulsat per {name}",
  "status.reblogs.empty": "Encara no ha impulsat ningú aquest tut. Quan algú ho faci, apareixerà aquí.",
  "status.reblogs_count": "{count, plural, one {{counter} impuls} other {{counter} impulsos}}",
  "status.redraft": "Esborra i reescriu",
  "status.remove_bookmark": "Elimina el marcador",
  "status.remove_favourite": "Elimina dels preferits",
  "status.remove_quote": "Elimina",
  "status.replied_in_thread": "Respost al fil",
  "status.replied_to": "En resposta a {name}",
  "status.reply": "Respon",
  "status.replyAll": "Respon al fil",
  "status.report": "Denuncia @{name}",
  "status.request_quote": "Petició per a citar",
  "status.revoke_quote": "Elimina la meva publicació de la de @{name}",
  "status.sensitive_warning": "Contingut sensible",
  "status.share": "Comparteix",
  "status.show_less_all": "Mostra'n menys per a tot",
  "status.show_more_all": "Mostra'n més per a tot",
  "status.show_original": "Mostra l'original",
  "status.title.with_attachments": "{user} ha publicat {attachmentCount, plural, one {un adjunt} other {{attachmentCount} adjunts}}",
  "status.translate": "Tradueix",
  "status.translated_from_with": "Traduït del {lang} fent servir {provider}",
  "status.uncached_media_warning": "Previsualització no disponible",
  "status.unmute_conversation": "Deixa de silenciar la conversa",
  "status.unpin": "Desfixa del perfil",
  "subscribed_languages.lead": "Només els tuts en les llengües seleccionades apareixeran en les teves línies de temps \"Inici\" i \"Llistes\" després del canvi. No en seleccionis cap per a rebre tuts en totes les llengües.",
  "subscribed_languages.save": "Desa els canvis",
  "subscribed_languages.target": "Canvia les llengües subscrites per a {target}",
  "tabs_bar.home": "Inici",
  "tabs_bar.menu": "Menú",
  "tabs_bar.notifications": "Notificacions",
  "tabs_bar.publish": "Nova Publicació",
  "tabs_bar.search": "Cerca",
  "tag.remove": "Elimina",
  "terms_of_service.effective_as_of": "En vigor a partir de {date}",
  "terms_of_service.title": "Condicions de servei",
  "terms_of_service.upcoming_changes_on": "Propers canvis el {date}",
  "time_remaining.days": "{number, plural, one {# dia restant} other {# dies restants}}",
  "time_remaining.hours": "{number, plural, one {# hora restant} other {# hores restants}}",
  "time_remaining.minutes": "{number, plural, one {# minut restant} other {# minuts restants}}",
  "time_remaining.moments": "Moments restants",
  "time_remaining.seconds": "{number, plural, one {# segon restant} other {# segons restants}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} persones}} en {days, plural, one {el passat dia} other {els passats {days} dies}}",
  "trends.trending_now": "És tendència",
  "ui.beforeunload": "El teu esborrany es perdrà si surts de Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Arrossega i deixa anar per a carregar",
  "upload_button.label": "Afegeix imatges, un vídeo o un fitxer d'àudio",
  "upload_error.limit": "S'ha superat el límit de càrrega d'arxius.",
  "upload_error.poll": "No es permet carregar fitxers a les enquestes.",
  "upload_error.quote": "No es permet de carregat fitxer amb cites.",
  "upload_form.drag_and_drop.instructions": "Per a agafar un fitxer multimèdia adjunt, premeu l'espai o la tecla Enter. Mentre l'arrossegueu, utilitzeu les fletxes per a moure l'adjunt en qualsevol direcció. Premeu espai o Enter un altre cop per a deixar-lo anar a la seva nova posició, o premeu la tecla d'escapament per cancel·lar.",
  "upload_form.drag_and_drop.on_drag_cancel": "S'ha cancel·lat l'arrossegament. S'ha deixat anar l'adjunt multimèdia {item}.",
  "upload_form.drag_and_drop.on_drag_end": "S'ha deixat anar l'adjunt multimèdia {item}.",
  "upload_form.drag_and_drop.on_drag_over": "S'ha mogut l'adjunt multimèdia {item}.",
  "upload_form.drag_and_drop.on_drag_start": "S'ha agafat l'adjunt multimèdia {item}.",
  "upload_form.edit": "Edita",
  "upload_progress.label": "Pujant...",
  "upload_progress.processing": "En procés…",
  "username.taken": "Aquest nom d'usuari ja està agafat. Prova un altre",
  "video.close": "Tanca el vídeo",
  "video.download": "Descarrega l’arxiu",
  "video.exit_fullscreen": "Surt de la pantalla completa",
  "video.expand": "Amplia el vídeo",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Amaga el vídeo",
  "video.mute": "Silencia",
  "video.pause": "Pausa",
  "video.play": "Reprodueix",
  "video.skip_backward": "Salta enrere",
  "video.skip_forward": "Salta endavant",
  "video.unmute": "Deixa de silenciar",
  "video.volume_down": "Abaixa el volum",
  "video.volume_up": "Apuja el volum",
  "visibility_modal.button_title": "Establiu la visibilitat",
  "visibility_modal.direct_quote_warning.text": "Si deseu la configuració actual, la cita incrustada es convertirà en un enllaç.",
  "visibility_modal.direct_quote_warning.title": "Les cites no es poden incrustar a les mencions privades",
  "visibility_modal.header": "Visibilitat i interacció",
  "visibility_modal.helper.direct_quoting": "No es poden citar mencions privades fetes a Mastondon.",
  "visibility_modal.helper.privacy_editing": "La visibilitat no es pot canviar després s'ha fet una publicació.",
  "visibility_modal.helper.privacy_private_self_quote": "Les autocites de publicacions privades no es poden fer públiques.",
  "visibility_modal.helper.private_quoting": "No es poden citar publicacions fetes a Mastodon només per a seguidors.",
  "visibility_modal.helper.unlisted_quoting": "Quan la gent us citi, les seves publicacions quedaran amagades de les línies de temps de tendències.",
  "visibility_modal.instructions": "Controleu qui pot interactuar amb aquesta publicació. També podeu aplicar la configuració a totes les publicacions futures navegant a <link>Preferències > Valors per defecte de publicació</link>.",
  "visibility_modal.privacy_label": "Visibilitat",
  "visibility_modal.quote_followers": "Només seguidors",
  "visibility_modal.quote_label": "Qui pot citar",
  "visibility_modal.quote_nobody": "Només jo",
  "visibility_modal.quote_public": "Qualsevol",
  "visibility_modal.save": "Desa"
}
